module.exports = __webpack_public_path__ + "img/syn_10scenes.4c46a32c.png";